"use client";
import "../chunk-GOCCUU3Z.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from "@getpara/react-components";
import styled from "styled-components";
import { useCopyToClipboard } from "../hooks/index.js";
import { isMobile } from "@getpara/web-sdk";
const QRCode = ({ link, imageSrc, icon, qrSize = 202, spinnerSize = 60 }) => {
  const [isCopied, copy] = useCopyToClipboard();
  const isMobileScreen = isMobile();
  const handleCopy = () => {
    copy(link);
  };
  return /* @__PURE__ */ jsxs(QRContainer, { $isMobile: isMobileScreen, children: [
    isMobileScreen && /* @__PURE__ */ jsxs(MobileCopyButton, { fullWidth: true, onClick: handleCopy, children: [
      /* @__PURE__ */ jsx(CopyIcon, { slot: "start", icon: isCopied ? "check" : "copy" }),
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyS", children: isCopied ? "Copied" : "Copy Link Instead" })
    ] }),
    !link ? /* @__PURE__ */ jsx(LoadingContainer, { $size: qrSize, children: /* @__PURE__ */ jsx(CpslSpinner, { size: spinnerSize }) }) : /* @__PURE__ */ jsx(StyledQRCode, { url: link, size: qrSize, icon, imageSrc }),
    !isMobileScreen && /* @__PURE__ */ jsxs(CopyButton, { size: "small", onClick: handleCopy, children: [
      /* @__PURE__ */ jsx(CopyIcon, { slot: "start", icon: isCopied ? "check" : "copy" }),
      /* @__PURE__ */ jsx(CpslText, { variant: "body2XS", children: isCopied ? "Copied" : "Copy Link Instead" })
    ] })
  ] });
};
const QRContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  border-color: var(--cpsl-color-background-16);
  border-radius: 16px;
  background-color: white;
  overflow: hidden;
  padding-bottom: ${({ $isMobile }) => $isMobile ? "0px" : "16px"};
  padding-top: ${({ $isMobile }) => $isMobile ? "16px" : "0px"};
`;
const StyledQRCode = styled(CpslQrCode)`
  --qr-box-shadow: none;
  --qr-border-radius: 0px;
`;
const CopyButton = styled(CpslButton)`
  --button-primary-color: var(--cpsl-color-text-contrast);
  --button-primary-background-color: var(--cpsl-color-background-4);

  --button-primary-hover-color: var(--cpsl-color-text-contrast);
  --button-primary-hover-background-color: var(--cpsl-color-background-16);

  --button-primary-active-color: var(--cpsl-color-text-contrast);
  --button-primary-active-background-color: var(--cpsl-color-background-4);

  --button-padding-start: 8px;
  --button-padding-end: 8px;
  --button-padding-top: 2px;
  --button-padding-bottom: 2px;

  --button-border-radius: 1000px;
`;
const MobileCopyButton = styled(CopyButton)`
  --button-padding-top: 4px;
  --button-padding-bottom: 4px;

  padding: 0px 12px;
`;
const CopyIcon = styled(CpslIcon)`
  --width: 16px;
  --height: 16px;
  --icon-color: var(--cpsl-color-text-contrast);
`;
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
`;
export {
  QRCode
};
